import axiosInstance from '../../utils/axiosConfig';

export const FETCH_MESSAGE_EVENTS_REQUEST = "FETCH_MESSAGE_EVENTS_REQUEST";
export const FETCH_MESSAGE_EVENTS_SUCCESS = "FETCH_MESSAGE_EVENTS_SUCCESS";
export const FETCH_MESSAGE_EVENTS_FAILURE = "FETCH_MESSAGE_EVENTS_FAILURE";
export const UPDATE_MESSAGE_EVENT_REQUEST = "UPDATE_MESSAGE_EVENT_REQUEST";
export const UPDATE_MESSAGE_EVENT_SUCCESS = "UPDATE_MESSAGE_EVENT_SUCCESS";
export const UPDATE_MESSAGE_EVENT_FAILURE = "UPDATE_MESSAGE_EVENT_FAILURE";

export const fetchMessageEvents = (scope, relatedEntity) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_MESSAGE_EVENTS_REQUEST });
    try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_COMMUNICATIONCHANNELS}/api/messageEvents/filter`;

      const response = await axiosInstance.post(
        url,
        {
          scope: scope,
          relatedEntity: relatedEntity,
          type: "ACTION_SCREEN_NOTIFICATION",
          status: "NEW",
        }
      );
      dispatch({ type: FETCH_MESSAGE_EVENTS_SUCCESS, payload: response.data });
      return response.data;  
    } catch (error) {
      dispatch({ type: FETCH_MESSAGE_EVENTS_FAILURE, error: error.message });
      throw error;  
    }
  };
};

export const updateMessageEvent = (id, updateData) => {
    return async (dispatch) => {
       dispatch({ type: UPDATE_MESSAGE_EVENT_REQUEST });
      try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_COMMUNICATIONCHANNELS}/api/messageEvents/${id}`;

        const response = await axiosInstance.put(
          url,
          updateData
        );
        dispatch({ type: UPDATE_MESSAGE_EVENT_SUCCESS, payload: response.data });
        return response.data;  
      } catch (error) {
        dispatch({ type: UPDATE_MESSAGE_EVENT_FAILURE, error: error.message });
        throw error;  
      }
    };
  };

  export const sendEmailEvents = (data) => async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_COMMUNICATIONCHANNELS}/api/messageEvents/filter`;
  
      const payload = {
        templateId: data.templateId,
        sender: "ghiloufiwassim@gmail.com",
        recipient: data.email,
        copyRecipient: "",
        hiddenRecipient: "",
        relatedEntity: "Password",
        // Les appelants passent déjà un objet `parameters` (expert.js, User.js) ; l'ancienne lecture à plat envoyait des valeurs vides
        parameters: data.parameters ?? {
          prenom: data.lastName,
          nom: data.firstName,
          username: data.username,
          password: data.password,
        },
      };
  
      const response = await axiosInstance.post(url, payload);
  
      // Dispatch a success action
      dispatch({ type: "SEND_EMAIL_SUCCESS", payload: response.data });
  
      console.log("Email sent successfully:", response.data);
      return response.data;
    } catch (error) {
      // Dispatch a failure action
      dispatch({ type: "SEND_EMAIL_FAILURE", error });
  
      console.error("Error sending email:", error);
      throw error; // Rethrow the error if further handling is needed
    }
  };
  
  